import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useGetIsUserAdminQuery, useListenUserProfileQuery } from 'modules/Users/userApi'
import { useGetContentStatsAccessQuery } from './contentStatsApi'

// Content Stats shows for coaches whose members were active enough (switched on by the monthly job)
// and always for Trybe admins. Shared by the menu and the route so both agree.
export function useCanSeeContentStats() {
  const { userId } = useAuth()
  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''
  const { data: trybeAdminValue, isLoading: adminLoading } = useGetIsUserAdminQuery({ userId }, { skip: !userId })
  const { data: access, isLoading: accessLoading } = useGetContentStatsAccessQuery({ coachOrgId }, { skip: !coachOrgId })
  const canSee = trybeAdminValue === 'admin' || access === 'on'
  return { canSee, isLoading: adminLoading || (Boolean(coachOrgId) && accessLoading) }
}
